import { capFirstChar } from 'src/helpers/utilities';
import { format } from 'svelte-i18n';
import { get } from 'svelte/store';

export function selectWeatherConditions(options) {
	if (options.length > 0) {
		return options.map((el) => {
			return {
				title: capFirstChar(get(format)(el.i18n)),
				value: el.cond,
				// disabled: el?.disabled
			};
		});
	}
	return [];
}
